<template>
    <div>
        <div class="fixed pin-b shadow-md bg-white w-full z-50 block lg:hidden no-print">
            <div class="flex h-4xl">
                <button
                    :class="{ 'is-active': show }"
                    class="menu-item flex-grow bg-ownit-red text-white md:flex-none md:w-sidebar"
                    @click="toggle"
                >
                    <div class="flex items-center relative">
                        <div class="hamburger-menu-icon">
                            <span />
                            <span />
                            <span />
                        </div>
                        <div
                            v-if="unreadSupportTicketsCount > 0"
                            class="absolute pin-t pin-r -mr-xs -mt-px h-lg w-lg flex items-center justify-center rounded-full border border-white bg-accent-yellow text-xs text-black p-xs"
                        >
                            {{ unreadSupportTicketsCount }}
                        </div>
                    </div>
                    <div class="text-xs mt-auto">
                        {{ lang('Meny', 'Menu') }}
                    </div>
                </button>
                <a :href="route('front.my-pages.index')" class="menu-item flex-grow text-neutral-dark">
                    <div class="h-2xl flex items-center">
                        <font-awesome-icon icon="globe-europe" class="text-lg" />
                    </div>
                    <div class="text-xs mt-auto">
                        {{ lang('Översikt', 'Overview') }}
                    </div>
                </a>
                <a :href="route('front.my-pages.messages.index')" class="menu-item flex-grow text-neutral-dark">
                    <div class="h-2xl flex items-center relative">
                        <font-awesome-icon icon="inbox" class="text-lg" />
                        <div
                            v-if="unreadMessagesCount > 0"
                            class="absolute pin-t pin-r -mr-xs -mt-px h-lg w-lg flex items-center justify-center rounded-full border border-white bg-accent-yellow text-xs text-black p-xs"
                        >
                            {{ unreadMessagesCount }}
                        </div>
                    </div>
                    <div class="text-xs mt-auto">
                        {{ lang('Inkorg', 'Inbox') }}
                    </div>
                </a>
                <a :href="route('front.my-pages.profile.show')" class="menu-item flex-grow text-neutral-dark">
                    <div class="flex justify-center items-center rounded-full bg-neutral-lighter" style="height:28px; width: 28px;">
                        <span class="text-xs font-bold">{{ $customer.short_username }}</span>
                    </div>
                    <div class="text-xs mt-auto">
                        {{ lang('Konto', 'Account') }}
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            unreadMessagesCount: {
                type: Number,
                default: null,
            },
            unreadSupportTicketsCount: {
                type: Number,
                default: null,
            },
        },
        data() {
            return {
                show: false,
            };
        },
        watch: {
            show(value) {
                if (value) {
                    document.body.classList.add('sidebar-open');
                } else {
                    document.body.classList.remove('sidebar-open');
                }
            },
        },
        methods: {
            toggle() {
                this.show = ! this.show;
            },
        },
    };
</script>
